import { IPastPsychiatricHistory } from "@curefit/ehr-common";
import { PatientPersonalProfile } from "@curefit/ups-common";
import * as React from "react"
import {isNull as _isNull} from "lodash"
import GenericEditViewCont from "../../containers/EditView/GenericEditViewCont";
import ErrorContainer from "../../containers/ErrorContainer";
import IDoctorProfile from "../../models/IDoctorProfile";
import IEditedBy from "../../models/IEditedBy";
import { ITypeFormResponse } from "../../models/ITypeFormResponse";
import { IEHRSavePatientMedicalProfile } from "../../models/patients/IEHRSavePatientMedicalProfile";
import { AppMessages, ConfigConstants, DoctorType, TabNames } from "../../utils/AppConstants";
import AppUtils from "../../utils/AppUtils";
import { EditViewDisplayMode } from "../common/EditViewCard";
import * as moment from "moment";
import CTA, {CTATheme} from "../common/CallToAction";

;

let count = [];
export interface PhysicalAssessmentTabProps {
    appointmentId?: number,
    editedBy: IEditedBy,
    patientId: number,
    currentMedicalProfile: IEHRSavePatientMedicalProfile,
    savePatientMedicalProfile: (patientId: number, patientMedicalProfile: any, appointmentId: number, doctorType: string) => Promise<any>,
    saveEditedMedicalProfile: (patientMedicalProfile: IEHRSavePatientMedicalProfile) => void,
    nextTab: () => void,
    patientPersonalProfile: PatientPersonalProfile,
    saveEditedPatientProfile: (patientPersonalProfile: PatientPersonalProfile) => void,
    updatePatientProfileData: (id: number, profile: PatientPersonalProfile) => Promise<any>,
    personalProfileId: number | string,
    patientTypeFormData: ITypeFormResponse;
    typeFormMapping: any;
    pastPsychiatricHistoryList: IPastPsychiatricHistory[],
    doctorType: string;
    isSelf: boolean,
    curefitUserId: number,
    uiConfiguration: any[],
    doctorProfile: IDoctorProfile;
    fetchPatientPastSessions: (patientId: number, subSectionKey: string) => Promise<any>;
}

export interface PhysicalAssessmentTabState {
    error: string,
    errorDetails?: string,
    isSaving?: boolean,
    tabWidgets: any
}

class PhysicalAssessmentTab extends React.Component<PhysicalAssessmentTabProps, PhysicalAssessmentTabState> {

    private isTherapist: boolean;
    private isPhysiotherapist: boolean;


    constructor(props: PhysicalAssessmentTabProps) {
        super(props);
        this.isTherapist = this.props.doctorType === DoctorType.MIND_THERAPIST;
        this.state = {
            error: null,
            errorDetails: null,
            isSaving: false,
            tabWidgets: this.props.uiConfiguration.filter((widget) => widget.sectionKey === TabNames.PHYSICAL_ASSESSMENT)
        }
    }

    componentDidMount() {
        document.getElementsByClassName("ongoing-consultation-main-cont")[0].scrollTop = 0;
    }

    componentWillUnmount() {
        this.saveEditedHistory();
    }

    getPatientphysicalAssessmentObject = () => {
        let physicalAssessmentObject: any = {};
        physicalAssessmentObject[ConfigConstants.NEWCONFIGDATA] = {};

        this.state.tabWidgets.map((widgetData:any) => {
            physicalAssessmentObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = (this as any | PhysicalAssessmentTab)[widgetData.subSectionKey].getSaveObject();
            if (physicalAssessmentObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey][widgetData.subSectionKey + "List"]
                && physicalAssessmentObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey][widgetData.subSectionKey + "List"].length > 0) {
                physicalAssessmentObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey]["assesor"] = this.props.doctorProfile.prefix + " " + this.props.doctorProfile.name;
                physicalAssessmentObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey]["date"] = moment().format("DD MMM, YYYY");
            } else {
                physicalAssessmentObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = {};
            }
        })
        return physicalAssessmentObject;
    }


    savePhysicalAssessment = () => {
        let patientMedicalProfile = this.getPatientphysicalAssessmentObject();
        this.saveEditedHistory();
        if (this.validateHistory()) {
            this.setState({ isSaving: true, error: null });
            this.props.savePatientMedicalProfile(this.props.patientId, patientMedicalProfile, this.props.appointmentId, this.props.doctorType).then(() => {
                this.props.nextTab();
            }).catch(err => {
                this.setState({
                    error: AppMessages.PHYSICAL_ASSESSMENT_SAVE_ERROR,
                    errorDetails: err.message,
                    isSaving: false
                })
            });
        }
    }

    saveEditedHistory = () => {
        let patientMedicalProfile = { ...this.props.currentMedicalProfile };
        this.state.tabWidgets.map((widgetData: { subSectionKey: "prescriptionAdvice" | "prescriptionDiagnosis" | "prescriptionInstructions" | "prescriptionLabTest" | "prescriptionMedicines" | "prescriptionFollowup"}) => {
            if (patientMedicalProfile.currentConsultationData)
                patientMedicalProfile.currentConsultationData[widgetData.subSectionKey] = (this as any | PhysicalAssessmentTab)[widgetData.subSectionKey].getSaveObject();
        })
    };

    clearErrorMessage = () => {
        this.setState({
            error: null,
            errorDetails: null
        })
    }

    validateHistory = (): boolean => {
        let status = true;
        let physicalAssessmentStatus: any = {};
        this.state.tabWidgets.map((widgetData:any) => {
            physicalAssessmentStatus[widgetData.subSectionKey] = (this as any | PhysicalAssessmentTab)[widgetData.subSectionKey].isFormDirty();
        })
        let isDirty = Object.values(physicalAssessmentStatus).findIndex(obj => obj === true) > -1;
        if (!physicalAssessmentStatus || isDirty) {
            this.state.tabWidgets.map((widgetData:any) => {
                if (physicalAssessmentStatus[widgetData.subSectionKey]) {
                    this.invalidItemError(widgetData.subSectionTitle);
                }
            })
            status = false;
        }
        return status;
    };


    invalidItemError = (sectionKey: string) => {
        this.setState({
            error: AppMessages.PHYSICAL_ASSESSMENT_VALIDATION_ERROR,
            errorDetails: `Error in ${sectionKey}. Please Review the form and proceed.`
        })
    };


    render() {
        let errorMessage = !_isNull(this.state.error) ? this.state.error : AppMessages.PHYSICAL_ASSESSMENT_SAVE_ERROR;
        let errorDetails = !_isNull(this.state.errorDetails) ? this.state.errorDetails : "";
        let saveButtonValue = this.state.isSaving ? "Saving..." : "Save";
        return (
            <div className="patient-history-tab-container">
                {
                    !_isNull(this.state.error) &&
                    <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0} closeError={this.clearErrorMessage}
                        reportError={true} rollbarPayload={{ message: errorMessage, errorDetails: errorDetails, request: this.getPatientphysicalAssessmentObject() }} />
                }

                {this.state.tabWidgets.map((widgetData: any, index: number) => {
                    let tabData = AppUtils.consultationDataDecider(this.props.currentMedicalProfile, false, widgetData.subSectionKey);

                    const modalHeaders: any = [{ label: "session", display: "Session ", valueKey: "sessionNo" },
                        { label: "date", display: "Date: ", valueKey: "date" },
                        { label: "assesor", display: "Assesor: ", valueKey: "assesor" }];

                    return <div key={widgetData.subSectionKey} className="patient-info-subsection concern-section">
                        <GenericEditViewCont appointmentId={this.props.appointmentId} patientId={this.props.patientId} doctorName={this.props.doctorProfile.name} fetchPatientPastSessions={this.props.fetchPatientPastSessions} ref={(physicalassessmentDOM) => { (this as any | PhysicalAssessmentTab)[widgetData.subSectionKey] = physicalassessmentDOM }} displayMode={EditViewDisplayMode.EDIT} widgetData={widgetData} tabData={tabData} modalHeaders={modalHeaders} />
                    </div>
                })}

                {this.props.uiConfiguration.length > 0 ? <div className={"save-button collapsible-card"}>
                    <CTA innerText={saveButtonValue} disabled={this.state.isSaving} theme={CTATheme.PRIMARY} onClick={() => {
                        this.savePhysicalAssessment();
                    }} customStyle={{display: "inline"}}/>
                </div> : "UI Configuration is not present in DB"}

            </div>
        );
    }
}

export default PhysicalAssessmentTab